import { Component, OnInit } from '@angular/core';
import { UserInfoService } from '../../services/security/user-info.service';
import { MenuService } from '../../services/menu/menu.service';
import { isAvailableFeature } from '../../services/featureToggling';
import { MatNavList, MatListItem, MatListItemIcon, MatListItemTitle, MatListItemMeta } from '@angular/material/list';
import { NgIf, NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-menu-navigation',
    templateUrl: './menu-navigation.component.html',
    styleUrls: ['./menu-navigation.component.scss'],
    imports: [MatNavList, NgIf, MatListItem, RouterLink, MatIcon, MatListItemIcon, MatListItemTitle, MatDivider, RouterLinkActive, MatListItemMeta, NgClass]
})
export class MenuNavigationComponent implements OnInit {
  public isSAF = false;
  public isDirection = false;
  public isChefService = false;
  public isCPRA = false;
  public isAdmin = false;

  public showSubMenuAdministration = false;

  public showNav = isAvailableFeature;

  constructor(
    private readonly userInfoService: UserInfoService,
    private menuService: MenuService
  ) {}

  ngOnInit(): void {
    this.userInfoService.afterLoadUserInfo().then((): void => {
      this.isSAF = this.userInfoService.isSAF();
      this.isDirection = this.userInfoService.isDirSousDir();
      this.isChefService = this.userInfoService.isChefService();
      this.isCPRA = this.userInfoService.isCPRA();
    });
  }

  accesExecutionBudgetaire(): boolean {
    return this.isSAF || this.isDirection || this.isChefService || this.isCPRA;
  }

  accesValidationVirement(): boolean {
    return this.isSAF || this.isDirection || this.isChefService;
  }

  accesBascule(): boolean {
    return this.isSAF;
  }

  accesChapitre(): boolean {
    return this.isSAF;
  }

  accesMarche(): boolean {
    return this.isSAF;
  }

  accesNature(): boolean {
    return this.isSAF;
  }

  accesProjet(): boolean {
    return this.isSAF;
  }

  accesImportFichier(): boolean {
    return this.isSAF;
  }

  accesService(): boolean {
    return this.isSAF;
  }

  accesOperation(): boolean {
    return this.isSAF;
  }

  accesAdresses(): boolean {
    return this.isSAF;
  }

  accesPdf(): boolean {
    return this.isSAF;
  }

  accesFournisseurs(): boolean {
    return this.isSAF;
  }

  accesSupportContratuel(): boolean {
    return this.isSAF;
  }

  toggleMenu(): void {
    this.menuService.emitToggleMenu();
  }

  accesValideurComplementaire(): boolean {
    return this.isSAF;
  }
}
